import { createSlice } from "@reduxjs/toolkit";
import { CartItems } from "../Interface/Order.interface";


interface CartState {
    isOrderPlaced: boolean;
    cartItems: CartItems[];
    orderTrackingData: any[]
}

const initialState: CartState = {
    isOrderPlaced: false,
    cartItems: [],
    orderTrackingData:[]
};


const OrderSlice = createSlice({
    name: 'orders',
    initialState,
    reducers: {
        fetchOrderSuccess(state, action) {
            
            state.isOrderPlaced = true;
            state.cartItems = action.payload; // or whatever you want to do with payload
        },
        clearCart(state) {
            state.cartItems = [];
            state.isOrderPlaced = false;
        },

        fetchOrderFailed(state) {
            state.isOrderPlaced = false
        },
        fetchOrderTrackingData(state,action){
            state.orderTrackingData=action.payload
        }
    }
})


export const { fetchOrderSuccess, fetchOrderFailed,fetchOrderTrackingData } = OrderSlice.actions

export default OrderSlice.reducer
